import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import UserPool from "./UserPool";
import { AccessToken, RefreshToken } from "./AccessToken";
import LoginImg from "../../assets/img/hlthtek-login.jpeg";
import LoginImg2 from "../../assets/img/hlthtek_login.jpg";
import { ChangeCursor } from "../hlthtek-demo/components/MiscFunctions";
import InfoVideo from "../../assets/abha_info.mp4";
// import 'bootstrap/dist/css/bootstrap.min.css';
import img1 from "../../assets/images/gallery/HTMATE_Icon.png";
import img2 from "../../assets/images/gallery/HRP1.jpg";
import img3 from "../../assets/images/gallery/Hpr.jpg";
import img4 from "../../assets/images/gallery/abdm.jpeg";
import img5 from "../../assets/images/gallery/fhrabdm.jpg";
import img6 from "../../assets/images/gallery/HRP2.jpg";
import HTMateIcon from "../../assets/images/gallery/B-T-HTHRP.svg";
import { toast } from "react-toastify";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import "./LoginPage.scss";
import Carousel from "react-bootstrap/Carousel";
import { Divider } from "@mui/material";
import { borderRadius } from "@mui/system";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import axios from "axios";
// const Item = styled('div')(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

// const Item = styled('div')(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
//   height: '900px',
// }));
const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
const Item = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // height: '60vh',
  overflow: "hidden",
  minHeight: "60vh",
}));

// const imgStyle = {
//   // width: '100%',
//   height: "80vh",
//   // maxHeight: '63vh',
//   // objectFit: 'cover',
//   borderRadius: "15px",
// };

// const imgStyle = {
//   width: '100%',
//   height: 'auto',
//   maxHeight: '63vh',
//   objectFit: 'cover',
//   borderRadius: "15px"
// };

function HTHRPHealthRepositoryProvider() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    watch: watch1,
    setValue: setValue1,
  } = useForm();
  const history = useHistory();
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [verifyCodeForm, setVerifyCodeForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const RESEND_OTP_TIMER = process.env.REACT_APP_RESEND_OTP_TIMER;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    sessionStorage.clear();
  }, []);

  // const onSubmit = async (data) => {
  //   setButtonDisabled(true);
  //   setTimeout(() => {
  //     setButtonDisabled(false);
  //   }, RESEND_OTP_TIMER);
  //   //ChangeCursor();

  //   if (environment !== "PROD") {
  //     AccessToken(data.userName, data.password);
  //     setTimeout(() => {
  //       const role = sessionStorage.getItem("roleType");
  //       if (role === "admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "facility admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "facility user") {
  //         //ChangeCursor();video
  //         history.push("/hlthtek-demo");
  //       } else if (role === "customer admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "partner admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else {
  //         //ChangeCursor();
  //         history.push("/hlthtek-demo");
  //       }
  //     }, 3000);
  //   } else {
  //     const cognitoUser = new CognitoUser({
  //       Username: data.userName,
  //       Pool: UserPool,
  //     });

  //     const authDetails = new AuthenticationDetails({
  //       Username: data.userName,
  //       Password: data.password,
  //     });

  //     setUser(data.userName);
  //     setPassword(data.password);
  //     try {
  //       cognitoUser.authenticateUser(authDetails, {
  //         onSuccess: () => {
  //           cognitoUser.getAttributeVerificationCode("email", {
  //             onSuccess: (success) => {
  //               console.log(success);
  //               setVerifyCodeForm(true);
  //               //ChangeCursor();
  //               reset();
  //             },
  //             onFailure: (err) => {
  //               console.log(err.message);
  //               toast.error(err);
  //               //ChangeCursor();
  //             },
  //           });
  //         },
  //         onFailure: (err) => {
  //           if (err.code === "UserNotConfirmedException") {
  //             console.log(
  //               "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
  //             );
  //             toast.error(
  //               "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
  //             );
  //           } else {
  //             console.log(err.message);
  //             toast.error(err.message);
  //           }
  //           //ChangeCursor();
  //         },
  //       });
  //     } catch (error) {
  //       if (error === "Error: Network Error") {
  //         console.log("System is under maintenance.Please try again.");
  //         toast.error("System is under maintenance.Please try again.");
  //       } else {
  //         console.log("Invalid user or password.");
  //         toast.error("Invalid user or password.");
  //       }
  //       //ChangeCursor();
  //     }
  //   }
  // };

  const onSubmit = async (data) => {
    setButtonDisabled(true);

    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);

    if (environment !== "PROD") {
      // Simulated non-production environment logic
      AccessToken(data.userName, data.password);
      setTimeout(() => {
        const role = sessionStorage.getItem("roleType");
      }, 3000);
    } else {
      // Production environment logic
      try {
        // const bodyFormData = {
        //   userName: data.userName,
        //   password: data.password,
        // };

        const bodyFormData = new FormData();
        bodyFormData.append("username", data.userName);
        bodyFormData.append("password", data.password);
        const response = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}login/`,
          bodyFormData
        );

        const { message, role, email, name, facility_name } = response.data;
        sessionStorage.setItem("accessToken", response.data.access);
        sessionStorage.setItem("refreshToken", response.data.refresh);
        sessionStorage.setItem("accessTokenTime", new Date().getTime());
        sessionStorage.setItem(
          "subscriptionType",
          response.data.subscription_type
        );
        sessionStorage.setItem("APP_MODE", "SaaS");
        sessionStorage.setItem("ORG_CODE", "ORG7AGIY");
        sessionStorage.setItem(
          "USER_ACCESS_KEY",
          "23ddd049-8e7c-45d9-8b65-c7db68fd5051"
        );

        if (response.data.role === "partner admin") {
          sessionStorage.setItem("partner_id", response.data.partner_id);
        } else if (response.data.role === "partner user") {
          sessionStorage.setItem("partner_id", response.data.partner_id);
        } else if (response.data.role === "customer user") {
          sessionStorage.setItem("customer_name", response.data.customer_name);
          sessionStorage.setItem("partner_id", response.data.partner_id);
        } else if (response.data.role === "customer admin") {
          sessionStorage.setItem("customer_name", response.data.customer_name);
          sessionStorage.setItem("partner_id", response.data.partner_id);
        } else if (response.data.role === "facility admin") {
          sessionStorage.setItem("facility_name", response.data.facility_name);
        } else if (response.data.role === "facility user") {
          sessionStorage.setItem("facility_name", response.data.facility_name);
        } else if (response.data.role === "doctor") {
          sessionStorage.setItem("facility_name", response.data.facility_id);
        }

        if (response.data && response.data.access) {
          // Save user data to sessionStorage
          sessionStorage.setItem("userName", data.userName);
          sessionStorage.setItem("roleType", role);
          sessionStorage.setItem("email", email);
          sessionStorage.setItem("name", name);
          if (response.data.role !== "doctor") {
            sessionStorage.setItem("facility_name", facility_name);
          }
          // if (role === "admin") {
          //   AccessToken(data.userName, data.password)
          //     .then(() => {
          //       history.push("/hlthtek-admin-demo");
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else if (role === "facility admin") {
          //   AccessToken(data.userName, data.password)
          //     .then(async () => {
          //       const subscriptionType =
          //         sessionStorage.getItem("subscriptionType");
          //       if (
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIU/HIP" ||
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIU" ||
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIP"
          //       ) {
          //         history.push("/hlthtek-admin-demo");
          //       } else {
          //         console.log(
          //           subscriptionType ===
          //             "Health Repository Provider (HRP) Service - HIU/HIP",
          //           "checking"
          //         );
          //         const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
          //         const confirmed = await showConfirmDialog(message);
          //         if (confirmed) {
          //           history.push("/hlthtek-admin-demo");
          //         } else {
          //           history.push("/");
          //           sessionStorage.clear();
          //           window.location.reload();
          //         }
          //       }
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else if (role === "facility user" || role === "user") {
          //   AccessToken(data.userName, data.password)
          //     .then(async () => {
          //       const subscriptionType =
          //         sessionStorage.getItem("subscriptionType");
          //       if (
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIU/HIP" ||
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIU" ||
          //         subscriptionType ===
          //           "Health Repository Provider (HRP) Service - HIP"
          //       ) {
          //         history.push("/hlthtek-demo");
          //       } else {
          //         console.log(
          //           subscriptionType ===
          //             "Health Repository Provider (HRP) Service - HIU/HIP",
          //           "checking"
          //         );
          //         const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
          //         const confirmed = await showConfirmDialog(message);
          //         if (confirmed) {
          //           history.push("/hlthtek-demo");
          //         } else {
          //           history.push("/");
          //           sessionStorage.clear();
          //           window.location.reload();
          //         }
          //       }
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else if (role === "customer admin") {
          //   AccessToken(data.userName, data.password)
          //     .then(() => {
          //       history.push("/hlthtek-admin-demo");
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else if (role === "partner admin") {
          //   AccessToken(data.userName, data.password)
          //     .then(() => {
          //       history.push("/hlthtek-admin-demo");
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else if (role === "doctor") {
          //   console.log("inside doc");
          //   toast.error("Please login with HTMATE");
          //   sessionStorage.clear();
          //   window.location.reload();
          // } else if (role === "lab user") {
          //   AccessToken(data.userName, data.password)
          //     .then(() => {
          //       history.push("/hlthtek-demo");
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // } else {
          //   AccessToken(data.userName, data.password)
          //     .then(() => {
          //       history.push("/hlthtek-demo");
          //     })
          //     .catch((error) => {
          //       console.error("Login failed:", error);
          //       toast.error(
          //         "Failed to login. Please check your credentials."
          //       );
          //     });
          // }

          if (role === "admin") {
            history.push("/hlthtek-admin-demo");
          } else if (role === "facility admin") {
            const subscriptionType = sessionStorage.getItem("subscriptionType");
            if (
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIU/HIP" ||
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIU" ||
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIP"
            ) {
              history.push("/hlthtek-admin-demo");
            } else {
              console.log(
                subscriptionType ===
                  "Health Repository Provider (HRP) Service - HIU/HIP",
                "checking"
              );
              const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
              showConfirmDialog(message).then((confirmed) => {
                if (confirmed) {
                  history.push("/hlthtek-admin-demo");
                } else {
                  history.push("/");
                  sessionStorage.clear();
                  window.location.reload();
                }
              });
            }
          } else if (role === "facility user" || role === "user") {
            const subscriptionType = sessionStorage.getItem("subscriptionType");
            if (
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIU/HIP" ||
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIU" ||
              subscriptionType ===
                "Health Repository Provider (HRP) Service - HIP"
            ) {
              history.push("/hlthtek-demo");
            } else {
              console.log(
                subscriptionType ===
                  "Health Repository Provider (HRP) Service - HIU/HIP",
                "checking"
              );
              const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
              showConfirmDialog(message).then((confirmed) => {
                if (confirmed) {
                  history.push("/hlthtek-demo");
                } else {
                  history.push("/");
                  sessionStorage.clear();
                  window.location.reload();
                }
              });
            }
          } else if (role === "customer admin") {
            history.push("/hlthtek-admin-demo");
          } else if (role === "partner admin") {
            history.push("/hlthtek-admin-demo");
          } else if (role === "doctor") {
            console.log("inside doc");
            toast.error("Please login with HTMATE");
            sessionStorage.clear();
            window.location.reload();
          } else if (role === "lab user") {
            history.push("/hlthtek-demo");
          } else {
            history.push("/hlthtek-demo");
          }
        } else {
          toast.error(response.data.detail);
        }
      } catch (error) {
        console.error("Authentication error:", error);
        if (error.response?.status === 401) {
          toast.error("Invalid username or password. Please try again.");
        } else {
          toast.error("An unexpected error occurred. Please try again later.");
        }
      }
    }
  };
  // const onSubmit = async (data) => {
  //   setButtonDisabled(true);
  //   setTimeout(() => {
  //     setButtonDisabled(false);
  //   }, RESEND_OTP_TIMER);
  //   //ChangeCursor();

  //   if (environment !== "PROD") {
  //     AccessToken(data.userName, data.password);
  //     setTimeout(() => {
  //       const role = sessionStorage.getItem("roleType");
  //       if (role === "admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "facility admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "facility user") {
  //         //ChangeCursor();video
  //         history.push("/hlthtek-demo");
  //       } else if (role === "customer admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else if (role === "partner admin") {
  //         //ChangeCursor();
  //         history.push("/hlthtek-admin-demo");
  //       } else {
  //         //ChangeCursor();
  //         history.push("/hlthtek-demo");
  //       }
  //     }, 3000);
  //   } else {
  //     const cognitoUser = new CognitoUser({
  //       Username: data.userName,
  //       Pool: UserPool,
  //     });

  //     const authDetails = new AuthenticationDetails({
  //       Username: data.userName,
  //       Password: data.password,
  //     });
  //     var role = "";
  //     var email = "";
  //     var name = "";
  //     var facility_name = "";

  //     setUser(data.userName);
  //     setPassword(data.password);
  //     try {
  //       cognitoUser.authenticateUser(authDetails, {
  //         onSuccess: () => {
  //           // cognitoUser.getAttributeVerificationCode("email", {
  //           //   onSuccess: (success) => {
  //           //     console.log(success);
  //           //     setVerifyCodeForm(true);
  //           //     //ChangeCursor();
  //           //     reset();
  //           //   },
  //           //   onFailure: (err) => {
  //           //     console.log(err.message);
  //           //     toast.error(err);
  //           //     //ChangeCursor();
  //           //   },
  //           // });

  //           cognitoUser.getUserAttributes(function (err, result) {
  //             if (err) {
  //               toast.error(err.message || JSON.stringify(err));
  //               //ChangeCursor();
  //               return;
  //             } else {
  //               console.log(result);
  //               sessionStorage.setItem("userName", data.userName);
  //               for (var i = 0; i < result.length; i++) {
  //                 if (result[i].getName() == "custom:role") {
  //                   role = result[i].getValue();
  //                   console.log("role", role);
  //                   sessionStorage.setItem("roleType", role);
  //                 }
  //                 if (result[i].getName() == "custom:name") {
  //                   name = result[i].getValue();
  //                   sessionStorage.setItem("name", name);
  //                   // console.log("testing..",name)
  //                 }
  //                 if (result[i].getName() == "custom:facility_name") {
  //                   facility_name = result[i].getValue();
  //                   sessionStorage.setItem("facility_name", facility_name);
  //                 }
  //                 if (result[i].getName() === "email") {
  //                   email = result[i].getValue();
  //                   sessionStorage.setItem("email", email);
  //                 }
  //               }
  //               if (role === "admin") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(() => {
  //                     history.push("/hlthtek-admin-demo");
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else if (role === "facility admin") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(async () => {
  //                     const subscriptionType =
  //                       sessionStorage.getItem("subscriptionType");
  //                     if (
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIU/HIP" ||
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIU" ||
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIP"
  //                     ) {
  //                       history.push("/hlthtek-admin-demo");
  //                     } else {
  //                       console.log(
  //                         subscriptionType ===
  //                           "Health Repository Provider (HRP) Service - HIU/HIP",
  //                         "checking"
  //                       );
  //                       const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
  //                       const confirmed = await showConfirmDialog(message);
  //                       if (confirmed) {
  //                         history.push("/hlthtek-admin-demo");
  //                       } else {
  //                         history.push("/");
  //                         sessionStorage.clear();
  //                         window.location.reload();
  //                       }
  //                     }
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else if (role === "facility user" || role === "user") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(async () => {
  //                     const subscriptionType =
  //                       sessionStorage.getItem("subscriptionType");
  //                     if (
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIU/HIP" ||
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIU" ||
  //                       subscriptionType ===
  //                         "Health Repository Provider (HRP) Service - HIP"
  //                     ) {
  //                       history.push("/hlthtek-demo");
  //                     } else {
  //                       console.log(
  //                         subscriptionType ===
  //                           "Health Repository Provider (HRP) Service - HIU/HIP",
  //                         "checking"
  //                       );
  //                       const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
  //                       const confirmed = await showConfirmDialog(message);
  //                       if (confirmed) {
  //                         history.push("/hlthtek-demo");
  //                       } else {
  //                         history.push("/");
  //                         sessionStorage.clear();
  //                         window.location.reload();
  //                       }
  //                     }
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else if (role === "customer admin") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(() => {
  //                     history.push("/hlthtek-admin-demo");
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else if (role === "partner admin") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(() => {
  //                     history.push("/hlthtek-admin-demo");
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else if (role === "doctor") {
  //                 console.log("inside doc");
  //                 toast.error("Please login with HTMATE");
  //                 sessionStorage.clear();
  //                 window.location.reload();
  //               } else if (role === "lab user") {
  //                 AccessToken(data.userName, data.password)
  //                   .then(() => {
  //                     history.push("/hlthtek-demo");
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               } else {
  //                 AccessToken(data.userName, data.password)
  //                   .then(() => {
  //                     history.push("/hlthtek-demo");
  //                   })
  //                   .catch((error) => {
  //                     console.error("Login failed:", error);
  //                     toast.error(
  //                       "Failed to login. Please check your credentials."
  //                     );
  //                   });
  //               }
  //             }
  //           });
  //         },
  //         onFailure: (err) => {
  //           if (err.code === "UserNotConfirmedException") {
  //             console.log(
  //               "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
  //             );
  //             toast.error(
  //               "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
  //             );
  //           } else {
  //             console.log(err.message);
  //             toast.error(err.message);
  //           }
  //           //ChangeCursor();
  //         },
  //       });
  //     } catch (error) {
  //       if (error === "Error: Network Error") {
  //         console.log("System is under maintenance.Please try again.");
  //         toast.error("System is under maintenance.Please try again.");
  //       } else {
  //         console.log("Invalid user or password.");
  //         toast.error("Invalid user or password.");
  //       }
  //       //ChangeCursor();
  //     }
  //   }
  // };
  const onSubmit1 = async (data) => {
    //ChangeCursor();
    var role = "";
    var email = "";
    var name = "";
    var facility_name = "";

    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });

    try {
      cognitoUser.authenticateUser(authDetails, {
        onSuccess: () => {
          cognitoUser.verifyAttribute("email", data.verifyCode, {
            onSuccess: () => {
              cognitoUser.getUserAttributes(function (err, result) {
                if (err) {
                  toast.error(err.message || JSON.stringify(err));
                  //ChangeCursor();
                  return;
                } else {
                  console.log(result);
                  sessionStorage.setItem("userName", user);
                  for (var i = 0; i < result.length; i++) {
                    if (result[i].getName() == "custom:role") {
                      role = result[i].getValue();
                      console.log("role", role);
                      sessionStorage.setItem("roleType", role);
                    }
                    if (result[i].getName() == "custom:name") {
                      name = result[i].getValue();
                      sessionStorage.setItem("name", name);
                      // console.log("testing..",name)
                    }
                    if (result[i].getName() == "custom:facility_name") {
                      facility_name = result[i].getValue();
                      sessionStorage.setItem("facility_name", facility_name);
                    }
                    if (result[i].getName() === "email") {
                      email = result[i].getValue();
                      sessionStorage.setItem("email", email);
                    }
                  }
                  if (role === "admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "facility admin") {
                    AccessToken(data.userName, data.password)
                      .then(async () => {
                        const subscriptionType =
                          sessionStorage.getItem("subscriptionType");
                        if (
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIU/HIP" ||
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIU" ||
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIP"
                        ) {
                          history.push("/hlthtek-admin-demo");
                        } else {
                          console.log(
                            subscriptionType ===
                              "Health Repository Provider (HRP) Service - HIU/HIP",
                            "checking"
                          );
                          const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
                          const confirmed = await showConfirmDialog(message);
                          if (confirmed) {
                            history.push("/hlthtek-admin-demo");
                          } else {
                            sessionStorage.clear();
                            window.location.reload();
                            history.push("/");
                          }
                        }
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "facility user" || role === "user") {
                    AccessToken(data.userName, data.password)
                      .then(async () => {
                        const subscriptionType =
                          sessionStorage.getItem("subscriptionType");
                        if (
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIU/HIP" ||
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIU" ||
                          subscriptionType ===
                            "Health Repository Provider (HRP) Service - HIP"
                        ) {
                          history.push("/hlthtek-demo");
                        } else {
                          console.log(
                            subscriptionType ===
                              "Health Repository Provider (HRP) Service - HIU/HIP",
                            "checking"
                          );
                          const message = `Your subscription type does not match. Would you like to proceed with your current subscription type: <strong>${subscriptionType}</strong>?`;
                          const confirmed = await showConfirmDialog(message);
                          if (confirmed) {
                            history.push("/hlthtek-demo");
                          } else {
                            sessionStorage.clear();
                            window.location.reload();
                            history.push("/");
                          }
                        }
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "customer admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "partner admin") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-admin-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else if (role === "doctor") {
                    console.log("inside doc");
                    toast.error("Please login with HTMATE");
                    sessionStorage.clear();
                    window.location.reload();
                  } else if (role === "lab user") {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  } else {
                    AccessToken(data.userName, data.password)
                      .then(() => {
                        history.push("/hlthtek-demo");
                      })
                      .catch((error) => {
                        console.error("Login failed:", error);
                        toast.error(
                          "Failed to login. Please check your credentials."
                        );
                      });
                  }
                }
              });
            },
            onFailure: (err) => {
              console.log(err.message);
              toast.error(err.message);
              //ChangeCursor();
            },
          });
        },
        onFailure: (err) => {
          console.log(err.message);
          toast.error(err.message);
          //ChangeCursor();
        },
      });
    } catch (error) {
      if (error === "Error: Network Error") {
        console.log("System is under maintenance.Please try again.");
        toast.error("System is under maintenance.Please try again.");
      } else {
        toast.error("Invalid user or password.");
        console.log("Invalid user or password.");
      }
      //ChangeCursor();
    }
  };

  const resendCode = () => {
    setButtonDisabled(true);
    setTimeout(() => {
      setButtonDisabled(false);
    }, RESEND_OTP_TIMER);
    //ChangeCursor();
    const cognitoUser = new CognitoUser({
      Username: user,
      Pool: UserPool,
    });

    const authDetails = new AuthenticationDetails({
      Username: user,
      Password: password,
    });
    cognitoUser.authenticateUser(authDetails, {
      onSuccess: () => {
        cognitoUser.getAttributeVerificationCode("email", {
          onSuccess: (success) => {
            console.log(success);
            setVerifyCodeForm(true);
            //ChangeCursor();
          },
          onFailure: (err) => {
            console.log(err.message);
            toast.error(err);
            //ChangeCursor();
          },
        });
      },
      onFailure: (err) => {
        if (err.code === "UserNotConfirmedException") {
          console.log(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
          toast.error(
            "User account is not confirmed yet, please follow a link sent to your gmail to confirm you account!"
          );
        } else {
          console.log(err.message);
          toast.error(err.message);
        }
        //ChangeCursor();
      },
    });
  };

  const handlePlay = () => {
    let vid = document.getElementById("myVideo");
    if (vid.paused) {
      vid.play();
    } else {
      vid.pause();
    }
  };

  return (
    <div className="signupbox">
      <div className="wrapper">
        <div
          className="footer"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <Box sx={{ width: "100%" }}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              style={{
                backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                style={{
                  backgroundImage:
                    "url('../../assets/images/backgrounds/2.jpg')",
                }}
              >
                <Item
                  style={{
                    marginTop: "12px",
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  <Carousel style={{ marginBottom: "1%", objectFit: "cover" }}>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img2}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img3}
                        alt="Second slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img6}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img5}
                        alt="Third slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img2}
                        alt="First slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100 carousel-image"
                        src={img4}
                        alt="Third slide"
                      />
                      <Carousel.Caption></Carousel.Caption>
                    </Carousel.Item>
                  </Carousel>
                </Item>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Item
                  style={{
                    marginTop: "12px",
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  {!verifyCodeForm ? (
                    <div className="footer-widget-contact additional-footer-styles">
                      {/* <h6 className="footer-widget__title color-heading">
                      Hi, <span>Welcome!</span>
                    </h6> */}
                      {/* <img src={HTMateIcon} className="icon-size" /> */}
                      <Box
                        component="img"
                        src={HTMateIcon}
                        alt="HT Mate Icon"
                        sx={{
                          borderRadius: "5px",
                          width: { xs: 150, sm: 210, md: 255, lg: 300 }, // Responsive width
                          height: { xs: 65, sm: 91, md: 110, lg: 130 }, // Responsive height
                        }}
                      />
                      <form
                        className="contact-list list-unstyled"
                        name="login"
                        id="login"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <li>
                          {/* <h6> HTHRP</h6> */}
                          <h6>Your Digital Healthcare Partner</h6>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <input
                              name="userName"
                              type="text"
                              className="form-control"
                              required={true}
                              Placeholder="Username"
                              {...register("userName", {
                                required: "Facility ID is required.",
                              })}
                            />
                          </div>
                        </li>
                        <li>
                          <div
                            className="col-sm-12 col-md-12 col-lg-12"
                            style={{ position: "relative" }}
                          >
                            <input
                              name="password"
                              className="form-control"
                              type={showPassword ? "text" : "password"}
                              required={true}
                              placeholder="Password"
                              {...register("password", {
                                required: "Facility ID is required.",
                              })}
                            />
                            <span
                              className="password-toggle"
                              onClick={togglePasswordVisibility}
                              style={{
                                position: "absolute",
                                right: "40px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                            >
                              {/* Use an icon (e.g., Font Awesome) for the eye icon */}
                              {showPassword ? (
                                <i className="fas fa-eye-slash"></i>
                              ) : (
                                <i className="fas fa-eye"></i>
                              )}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <button
                              className="btn btn__secondary  mt-10"
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </li>
                      </form>
                      {/* <div className="d-flex align-items-center" style={{ paddingTop: '20px' }}>
                                            Doesn't have an account? 
                                                <a href="/register" className="btn btn__primary btn__link mr-30">
                                                    <i className="icon-arrow-right"></i> <span>Click here to Register</span>
                                                </a>
                                            </div> */}
                      {/* <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <a href="#" className="btn btn__primary btn__link mr-30">
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Get Directions</span>
                          </a>
                          <a href="#" className="btn btn__primary btn__link mr-30">
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Get Directions</span>
                          </a>
                        </div>

                        <ul className="social-icons list-unstyled mb-0">
                          <li>
                            <a href="#">
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i className="fab fa-twitter"></i>
                            </a>
                          </li>
                        </ul>
                      </div> */}
                      <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <a href="#" className="btn btn__primary btn__link mr-30">
                              <i className="icon-arrow-right"></i>{" "}
                              <span>Get Directions</span>
                            </a> */}
                            <ul
                              className="social-icons list-unstyled mb-0"
                              style={{ display: "flex", marginLeft: "60px" }}
                            >
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a
                            href="/contact"
                            className="btn btn__primary btn__link mr-30"
                          >
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Contact Hlthtek Helpdesk</span>
                          </a>
                        </div>
                      </div>
                      <div style={{ marginTop: "10px", color: "#0e204d" }}>
                        <span style={{ color: "#0e204d" }}>
                          Login to access your secure and personalized health
                          platform.
                        </span>
                        <span style={{ color: "#0e204d" }}>
                          Experience the future of healthcare with Hlthtek.com's
                          powerful HRP system aka HTHRP!
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="footer-widget-contact additional-footer-styles">
                      {/* <h6 className="footer-widget__title color-heading">
        Code, <span>Required!</span>
      </h6> */}
                      {/* <img src={HTMateIcon} className="icon-size" /> */}
                      <Box
                        component="img"
                        src={HTMateIcon}
                        alt="HT Mate Icon"
                        sx={{
                          borderRadius: "5px",
                          width: { xs: 150, sm: 210, md: 255, lg: 300 }, // Responsive width
                          height: { xs: 65, sm: 91, md: 110, lg: 130 }, // Responsive height
                        }}
                      />
                      <form
                        autoComplete="off"
                        className="contact-list list-unstyled"
                        name="code_confirm"
                        id="code_confirm"
                        onSubmit={handleSubmit1(onSubmit1)}
                      >
                        {/* <li>
          <h5>Please enter the code sent.</h5>
        </li> */}
                        <li>
                          {/* <h6> HTHRP</h6> */}
                          <h6>Your Digital Healthcare Partner</h6>
                        </li>
                        <li>
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <input
                              name="verifyCode"
                              id="verifyCode"
                              className="form-control"
                              type="number"
                              required={true}
                              Placeholder="Verify Code"
                              {...register1("verifyCode", {
                                required: "Verify Code is required.",
                              })}
                            />
                          </div>
                        </li>
                        <li>
                          <div
                            className="col-sm-12 col-md-12 col-lg-12"
                            // style={{ paddingLeft: "25%" }}
                          >
                            <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                            <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                type="button"
                                disabled={buttonDisabled}
                                onClick={() => resendCode()}
                              >
                                Resend Code
                              </button>
                            </div>
                            {/* <div>
                              <button
                                className="btn btn__secondary  mt-10"
                                onClick={() => {
                                  setValue1("verifyCode", "");
                                  setVerifyCodeForm(false);
                                }}
                                type="submit"
                              >
                                Cancel
                              </button>
                            </div> */}
                          </div>
                        </li>
                      </form>
                      {/* <div
        className="d-flex align-items-center"
        style={{ paddingTop: "20px" }}
      >
        <a
          href="https://www.abdm.gov.in/"
          className="btn btn__primary btn__link mr-30"
        >
          <i className="icon-arrow-right"></i>{" "}
          <span>Know More on ABDM</span>
        </a>
        <ul className="social-icons list-unstyled mb-0">
          <li>
            <a href="#">
              <i className="fab fa-facebook-f"></i>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fab fa-twitter"></i>
            </a>
          </li>
        </ul>
      </div> */}
                      <div
                        className="d-flex align-items-center"
                        style={{ paddingTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {/* <a href="#" className="btn btn__primary btn__link mr-30">
          <i className="icon-arrow-right"></i>{" "}
          <span>Get Directions</span>
        </a> */}
                            <ul
                              className="social-icons list-unstyled mb-0"
                              style={{ display: "flex", marginLeft: "60px" }}
                            >
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-facebook-f"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-instagram"></i>
                                </a>
                              </li>
                              <li style={{ marginRight: "10px" }}>
                                <a href="#">
                                  <i className="fab fa-twitter"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <a
                            href="/contact"
                            className="btn btn__primary btn__link mr-30"
                          >
                            <i className="icon-arrow-right"></i>{" "}
                            <span>Contact Hlthtek Helpdesk</span>
                          </a>
                        </div>
                      </div>
                      <div style={{ marginTop: "10px", color: "#0e204d" }}>
                        <span style={{ color: "#0e204d" }}>
                          Login to access your secure and personalized health
                          platform.
                        </span>
                        <span style={{ color: "#0e204d" }}>
                          Experience the future of healthcare with Hlthtek.com's
                          powerful HRP system aka HTHRP!
                        </span>
                      </div>
                    </div>
                  )}
                </Item>
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{
                  backgroundImage:
                    "url('../../assets/images/backgrounds/2.jpg')",
                }}
              >
                <Item
                  style={{
                    backgroundImage:
                      "url('../../assets/images/backgrounds/2.jpg')",
                  }}
                >
                  <section className="contact-info py-0">
                    <div className="container">
                      <div className="row row-no-gutter boxes-wrapper">
                        <div className="col-sm-12 col-md-6">
                          <div className="contact-box">
                            <div
                              className="contact__icon mb-10"
                              style={{ margin: "auto" }}
                            >
                              <img
                                src="../../assets/images/icons/ehr_00.png"
                                alt="icon"
                              />
                            </div>
                            <div className="contact__content">
                              <h2 className="contact__title">
                                <a
                                  href="/resarch/home"
                                  className="contact__title"
                                >
                                  Features:
                                </a>
                              </h2>
                              <p className="contact__desc">
                                <li>
                                  <strong>
                                    ABHA Card Generation/Verification:
                                  </strong>{" "}
                                  Securely create and verify your unique digital
                                  health identifier, the ABHA card.
                                </li>
                                <li>
                                  Access your health records and share them
                                  securely with authorized healthcare providers.
                                </li>
                                <li>
                                  <strong>
                                    Health Data Linking for New & Past Records -
                                    HIP:
                                  </strong>{" "}
                                  Connect your new and past health records under
                                  a single ABHA Address, creating a
                                  comprehensive health profile.
                                </li>
                                <li>
                                  The Health Information Provider (HIP) allows
                                  you to manage and link your health data from
                                  different sources.
                                </li>
                                <li>
                                  <strong>
                                    Health Data Access (PAN-India) for Past
                                    Records - HIU:
                                  </strong>{" "}
                                  Retrieve and access your health data from
                                  various healthcare providers across India.
                                </li>
                                <li>
                                  The Health Information Utility (HIU) serves as
                                  a central repository for health data, ensuring
                                  nationwide access.
                                </li>
                                <li>
                                  <strong>Storage (24X7):</strong> Securely
                                  store your health data on the ABDM platform,
                                  accessible anytime, anywhere.
                                </li>
                                <li>
                                  Guaranteed 24/7 availability of your health
                                  information, ensuring continuity of care.
                                </li>
                                <li>
                                  <strong>
                                    Enhanced HMIS Plug-in/Integrations/Features:
                                  </strong>{" "}
                                  Streamline healthcare processes with enhanced
                                  integrations between the ABDM and HMIS
                                  systems.
                                </li>
                                <li>
                                  Improved features and functionalities for
                                  healthcare providers and patients, enabling
                                  efficient data sharing and improved services.
                                </li>
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-12 col-md-6">
                          <div className="contact-box">
                            <div
                              className="contact__icon mb-10"
                              style={{ margin: "auto" }}
                            >
                              <img
                                src="../../assets/images/icons/ehr_02.png"
                                alt="icon"
                              />
                            </div>
                            <div className="contact__content">
                              <h2 className="contact__title">
                                <a
                                  href="/doctor/home"
                                  className="contact__title"
                                >
                                  Benefits:
                                </a>
                              </h2>
                              <p className="contact__desc">
                                <li>
                                  <strong>
                                    Simplified Patient Identification:
                                  </strong>{" "}
                                  Easily identify patients through their unique
                                  ABHA cards, reducing errors and streamlining
                                  patient records.
                                </li>
                                <li>
                                  <strong>Improved Data Security:</strong>{" "}
                                  Securely access patient records through the
                                  ABDM platform, enhancing data privacy and
                                  patient trust.
                                </li>
                                <li>
                                  <strong>
                                    Comprehensive Patient History:
                                  </strong>{" "}
                                  Gain a complete view of patient health records
                                  from multiple sources, providing better
                                  informed care.
                                </li>
                                <li>
                                  <strong>Enhanced Patient Care:</strong> Access
                                  patient records from across India, enabling
                                  better coordination of care and reducing
                                  medical errors.
                                </li>
                                <li>
                                  <strong>Improved Patient Management:</strong>{" "}
                                  Seamlessly access and share patient health
                                  information with other healthcare providers,
                                  ensuring continuity of care.
                                </li>
                                <li>
                                  <strong>
                                    Secure and Reliable Data Storage:
                                  </strong>{" "}
                                  Ensure the safety and availability of patient
                                  data on demand, minimizing data loss and
                                  downtime.
                                </li>
                                <li>
                                  <strong>Improved Patient Experience:</strong>{" "}
                                  Provide patients with easy access to their
                                  records anytime, anywhere, empowering them to
                                  manage their health.
                                </li>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </Item>
              </Grid>
            </Grid>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default HTHRPHealthRepositoryProvider;
